import React from 'react';
import { Layout } from '../components/Layout';
import { CheckIcon } from 'lucide-react';
const tiers = [{
  name: 'Essential Reface',
  price: 'From $3,500',
  description: 'Perfect for a quick, high-impact refresh of your kitchen space.',
  features: ['Shaker Style Doors', 'Standard Hardware', 'High-Pressure Veneers', '2-Day Installation']
}, {
  name: 'Premium Transformation',
  price: 'From $5,500',
  description: 'Our most popular package featuring upgraded materials and soft-close tech.',
  features: ['Any Door Style', 'Soft-Close Hinges', 'Premium Hardware', 'Crown Molding', 'Full Warranty', '2-Day Installation'],
  highlight: true
}, {
  name: 'Luxury Custom',
  price: 'From $8,500',
  description: 'The ultimate kitchen overhaul with custom modifications and designer finishes.',
  features: ['Custom Door Styles', 'Designer Hardware', 'Cabinet Modifications', 'Integrated Lighting', 'Lifetime Warranty', '1-Day Priority Install']
}];
export function PricingPage() {
  return <Layout data-id="element-320">
      <div className="py-24 px-6 bg-white border-b-3 border-charcoal" data-id="element-321">
        <div className="max-w-7xl mx-auto text-center" data-id="element-322">
          <h1 className="text-6xl md:text-8xl font-bold mb-8" data-id="element-323">
            Transparent <br data-id="element-324" />
            <span className="italic font-serif font-normal text-espresso" data-id="element-325">
              Pricing
            </span>
          </h1>
          <p className="text-xl text-charcoal/60 max-w-2xl mx-auto leading-relaxed" data-id="element-326">
            No hidden fees. No upselling. Just honest, upfront pricing for
            premium craftsmanship.
          </p>
        </div>
      </div>
      <section className="py-24 px-6 bg-alabaster" data-id="element-327">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-328">
          {tiers.map(tier => <div key={tier.name} className={`p-8 md:p-12 border-3 border-charcoal flex flex-col ${tier.highlight ? 'bg-charcoal text-alabaster shadow-[12px_12px_0px_0px_rgba(150,90,66,1)]' : 'bg-white text-charcoal'}`} data-id="element-329">
              <h3 className="text-2xl font-bold mb-2" data-id="element-330">{tier.name}</h3>
              <p className={`text-4xl font-serif mb-6 ${tier.highlight ? 'text-espresso' : 'text-charcoal'}`} data-id="element-331">
                {tier.price}
              </p>
              <p className={`text-sm mb-8 ${tier.highlight ? 'text-alabaster/60' : 'text-charcoal/60'}`} data-id="element-332">
                {tier.description}
              </p>
              <ul className="space-y-4 mb-12 flex-grow" data-id="element-333">
                {tier.features.map(f => <li key={f} className="flex items-center gap-3 text-sm font-medium" data-id="element-334">
                    <CheckIcon className={`w-4 h-4 ${tier.highlight ? 'text-espresso' : 'text-espresso'}`} data-id="element-335" />
                    {f}
                  </li>)}
              </ul>
              <button className={`w-full py-4 font-bold uppercase tracking-widest text-sm transition-colors ${tier.highlight ? 'bg-espresso text-alabaster hover:bg-white hover:text-charcoal' : 'bg-charcoal text-alabaster hover:bg-espresso'}`} data-id="element-336">
                Select Package
              </button>
            </div>)}
        </div>
      </section>
    </Layout>;
}